// @flow

import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Button, MailIcon } from 'seek-style-guide/react';

import NavLink from 'src/components/NavLink/NavLink';

import buttonsStyles from '../../JobActionButtons.less';
import styles from './SendJobButton.less';
import { shareLinkClicked } from 'src/store/jobdetails/jobdetails';

type Props = {
  shareLinkClicked: Function,
  job: ChaliceJobDetail
};

const mapDispatchToProps = {
  shareLinkClicked
};

class SendJobButton extends Component<Props> {
  props: Props;

  handleClick = () => this.props.shareLinkClicked('email');

  render() {
    const location = {
      pathname: `/job/${this.props.job.id}`,
      query: { send: true }
    };

    return (
      <NavLink
        className={classnames(styles.button, buttonsStyles.hackWrap)}
        fullWidth
        color="gray"
        onClick={this.handleClick}
        component={Button}
        data-automation="job-detail-send-job"
        rel="nofollow"
        location={location}
      >
        <MailIcon svgClassName={styles.emailIconSvg} />
        Send job
      </NavLink>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(SendJobButton);
